import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import type {AnyObject} from 'swayok-react-mdb-ui-kit/types/Common'
import type {AdPropertyConfigForFilters} from '../../AdsModuleTypes'
import {ButtonsSwitchFilter} from './filters/ButtonsSwitchFilter'
import {CheckboxesFilter} from './filters/CheckboxesFilter'
import {ColorsFilter} from './filters/ColorsFilter'
import {RangeFilter} from './filters/RangeFilter'

interface AdCategoryFiltersDynamicInputsProps {
    configs: AdPropertyConfigForFilters[]
    values: AnyObject
    disabled?: boolean
    className?: string
    onChange: (setter: (props: AnyObject) => AnyObject) => void
}

// Фильтрация по динамическим свойствам объявлений.
export function AdCategoryFiltersDynamicInputs(props: AdCategoryFiltersDynamicInputsProps) {

    const {
        configs,
        values,
        disabled,
        className,
        onChange: propsOnChange,
    } = props

    // Сохранить новое значение поля ввода.
    const onChange = useEventCallback((
        name: string,
        value: unknown
    ) => {
        propsOnChange(values => ({...values, [name]: value}))
    })

    // Отрисовка поля ввода по конфигурации динамического свойства.
    const renderInput = (
        config: AdPropertyConfigForFilters,
        value: unknown
    ) => {
        switch (config.type) {
            case 'range':
                return (
                    <RangeFilter
                        key={config.name}
                        config={config}
                        value={value}
                        disabled={disabled}
                        onChange={onChange}
                    />
                )
            case 'checkboxes':
                if (!Array.isArray(value)) {
                    value = []
                }
                return (
                    <CheckboxesFilter
                        key={config.name}
                        config={config}
                        values={value as (string | number | null)[]}
                        disabled={disabled}
                        onChange={onChange}
                        minOptionsCountToEnableSearch={15}
                    />
                )
            case 'color':
                if (!Array.isArray(value)) {
                    value = []
                }
                return (
                    <ColorsFilter
                        key={config.name}
                        config={config}
                        values={value as (string | number | null)[]}
                        disabled={disabled}
                        onChange={onChange}
                    />
                )
            case 'buttons_switch':
                if (!['number', 'string', 'boolean'].includes(typeof value)) {
                    value = null
                }
                return (
                    <ButtonsSwitchFilter
                        key={config.name}
                        config={config}
                        value={value as string | number | null}
                        disabled={disabled}
                        onChange={onChange}
                    />
                )
            default:
                return null
        }
    }

    return (
        <Collapse show={configs.length > 0}>
            <div className={className}>
                {configs.map(
                    config => renderInput(
                        config,
                        values[config.name]
                    )
                )}
            </div>
        </Collapse>
    )
}
